import axios from "axios";
import { setLoader } from "../../../Slices/loaderSlice";
import { SERVER_URL } from "../../../databucket";
import { message } from "antd";

export const handleMultipleAttachment = async (event, details, dispatch, id, Empid, token) => {
    const employee = details?.find((emp) => emp?.id === id);
    const multipleFiles = Array.from(event.target.files);
    const formData = new FormData();
    multipleFiles.forEach(file => formData.append('files', file));

    try {
        dispatch(setLoader(true));

        const res = await axios.post(`${SERVER_URL}/upload`, formData);
        const uploadedFiles = res.data.files.map(uploadedItem => {
            const fileMeta = {
                _id: uploadedItem._id || undefined, // ✅ Include MongoDB ID if backend returns it
                userId: id,
                emailId: Empid,
                data: uploadedItem.url,
                replacedFile: null,
                userName: `${employee?.firstname ?? ''}${employee?.lastname ?? ''}`,
                filename: uploadedItem.originalName,
                mimetype: uploadedItem.mimeType,
                addDate: Date.now().toString(),
                updateDate: null,
                status: true,
                deleteDate: null,
                attachmetHistory: [{
                     userId: id,
                emailId: Empid,
                data: uploadedItem.url,
                replacedFile: null,
                userName: `${employee?.firstname ?? ''}${employee?.lastname ?? ''}`,
                filename: uploadedItem.originalName,
                mimetype: uploadedItem.mimeType,
                addDate: Date.now().toString(),
                updateDate: null,
                status: true,
                deleteDate: null,
                }
                ]
            };
            return fileMeta;
        });

        message.success({
            content: "Uploaded Successfully",
            duration: 2
        });

        return uploadedFiles;

    } catch (err) {
        message.error({
            content: "Upload failed",
            duration: 2
        });
        
    } finally {
        dispatch(setLoader(false));
    }
};
